// global-loading.store.ts
import { computed } from '@angular/core';
import { signalStore, withState, withComputed, withMethods, patchState } from '@ngrx/signals';
import { defer, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators'; // <— funktioniert stabil in RxJS 7

type GlobalLoadingState = {
  count: number;
};

export const GlobalLoadingStore = signalStore(
  { providedIn: 'root' },

  // 1) State (wird zu Signals: store.count())
  withState<GlobalLoadingState>({ count: 0 }),

  // 2) Computed Signals (werden zu store.active())
  withComputed((store) => ({
    active: computed(() => store.count() > 0),
  })),

  // 3) Methods (nutzen patchState(store, …))
  withMethods((store) => ({
    start() {
      patchState(store, { count: store.count() + 1 });
    },
    stop() {
      patchState(store, { count: Math.max(0, store.count() - 1) });
    },

    // Helper: umwickelt ein Observable mit globalem Loading
    withGlobalLoading<T>(source$: Observable<T>): Observable<T> {
      return defer(() => {
        // beim Subscribe++
        patchState(store, { count: store.count() + 1 });
        return source$.pipe(
          finalize(() => {
            // beim Complete/Error--
            patchState(store, { count: Math.max(0, store.count() - 1) });
          })
        );
      });
    },
  }))
);
